<template>

  <!--  <div class="template">-->
  <!--    <div class="d-block d-sm-none">XS</div>-->
  <!--    <div class="d-none d-sm-block d-md-none">SM</div>-->
  <!--    <div class="d-none d-md-block d-lg-none">MD</div>-->
  <!--    <div class="d-none d-lg-block d-xl-none">LG</div>-->
  <!--    <div class="d-none d-xl-block">XL</div>-->
  <!--  </div>-->

  <!-- <main-header></main-header> -->
  <div class="container-fluid p-0">

    <!-- Start section 1 -->
    <div class="" id="section-1">
      <div class="row mb-3">
        <div class="order-md-1 order-2 col-xl-5 offset-xl-1 col-lg-5 offset-lg-1   col-md-6 offset-md-1    col-sm-12 d-flex align-items-center justify-content-center">
          <div>
            <p class="title section-1-title text-center text-md-start">El éxito empresarial comienza con el bienestar mental de tu equipo</p>
            <p class="text-center text-md-start">MiMente es una plataforma digital que atiende la salud mental de Colaboradores de las empresas.</p>
            <p class="text-center text-md-start">Nuestras soluciones integrales, a través de tecnología de punta y un grupo de psicólogas y psicólogos expertos con atención personalizada, contribuyen a potenciar el talento humano y mejorar la productividad de las empresas.</p>
            <br>
            <div class="row">
              <div class="col-6 text-end d-block d-md-none">
                <a class="btn mm-btn mm-btn-primary btn-custom-padding uppercase custom-button" href="#section-9">Solicitar demo</a>
              </div>
              <div class="col-6">
                <a class="btn mm-btn mm-btn-primary btn-custom-padding uppercase custom-button contact-button-banner" href="#section-9">Contacto</a>
              </div>
            </div>
          </div>
        </div>
        <div class="order-md-2 order-1 col-xl-5             col-lg-5               col-md-5                col-sm-12 d-flex align-items-center justify-content-center mb-3">
          <img class="section-1-image" src="@/assets/landingpage/Mesa_de_trabajo-5_2.png" alt="">
        </div>
      </div>
    </div>
    <!-- End section 1 -->

    <!-- Start section 2 -->
    <div class="container-fuild bg-ligth-blue" id="section-2">
      <div class="row">
        <div class="col-sm-12 col-md-10 offset-md-1 text-center">
          <p class="title-2 section-2-title">MiMente: el beneficio más rentable para tu empresa</p>
        </div>
      </div>
    </div>
    <!-- End section 2 -->

    <!-- start section 3 -->
    <div class="container-fluid pt-5" id="section-3">
      <div class="row">
        <div class="col-12">
          <p class="title-3 section-3-title text-center">Tenemos lo mejor de dos mundos</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-5 offset-xl-1  col-lg-6 offset-lg-0      col-md-6    col-sm-12   ">
          <div class="section-3-grid mb-4 mb-md-0">
            <div class="img-container"><img src="@/assets/landingpage/landing-v4-06.svg" alt=""></div>
            <div>
              <p class="title-4 mb-3">Profesionales certificados</p>
              <p class="description">Seleccionamos cuidadosamente a nuestros psicólogos y psicólogas y procuramos que cuenten con las certificaciones (maestrías y doctorados) y las habilidades interpersonales para ofrecer la mejor atención.</p>
            </div>
          </div>
        </div>
        <div class="col-xl-5              col-lg-6                  col-md-6    col-sm-12               ">
          <div class="section-3-grid">
            <div class="img-container"><img src="@/assets/landingpage/landing-v4-07.svg" alt=""></div>
            <div>
              <p class="title-4 mb-3">Tecnología healthtech</p>
              <p class="description">Contamos con una app especializada para todo el personal, la operación de algoritmos para elegir al mejor terapeuta de acuerdo con las necesidades requeridas.</p>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="row mt-4 pb-5">-->
      <!--        <div class="col-12 text-center">-->
      <!--          <p class="sub-banner">Descubre cómo podemos transformar el bienestar de tu equipo</p>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!-- end section 3 -->

    <div class="container-fuild bg-ligth-blue" id="section-3_5">
      <div class="row">
        <div class="col-sm-12 col-md-10 offset-md-1 text-center">
          <p class="title-2 section-2-title">Descubre cómo podemos transformar el bienestar de tu equipo</p></div>
      </div>
    </div>

    <!-- start section 4 -->
    <div class="container-fluid d-none d-md-block" id="section-3">
      <div class="row">
        <div class="col-xl-10 offset-xl-1">

          <!-- inicio  -->
          <ul class="nav nav-pills mb-3 d-flex justify-content-around" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="btn mm-btn-tabs mm-btn-tab active" @click="onClickPill('pills-cuidado-preventivo')" data-bs-toggle="pill" data-bs-target="#pills-cuidado-preventivo" type="button" role="tab" aria-controls="pills-home" aria-selected="true">CUIDADO PREVENTIVO</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="btn mm-btn-tabs mm-btn-tab" @click="onClickPill('pills-cuidado-moderado')" data-bs-toggle="pill" data-bs-target="#pills-cuidado-moderado" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">CUIDADO MODERADO</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="btn mm-btn-tabs mm-btn-tab" @click="onClickPill('pills-cuidado-profundo')" data-bs-toggle="pill" data-bs-target="#pills-cuidado-profundo" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">CUIDADO PROFUNDO</button>
            </li>
          </ul>

          <ul class="nav nav-pills d-flex justify-content-around circles-content">
            <li>
              <div class="circle" :class="(pillClicked == 'pills-cuidado-preventivo') ? 'active' : ''"></div>
            </li>
            <li>
              <div class="circle" :class="(pillClicked == 'pills-cuidado-moderado') ? 'active' : ''"></div>
            </li>
            <li>
              <div class="circle" :class="(pillClicked == 'pills-cuidado-profundo') ? 'active' : ''"></div>
            </li>
          </ul>
          <div class="line-border"></div>

          <div class="tab-content mt-5" id="pills-tabContent">
            <div class="tab-pane show active" id="pills-cuidado-preventivo" role="tabpanel" aria-labelledby="pills-cuidado-preventivo-tab">
              <div class="row">
                <div class="col-xl-5 offset-xl-1 col-6 d-flex align-items-center justify-content-center">
                  <img class="" src="@/assets/landingpage/landing-v4-02.png" alt="">
                </div>
                <div class="col-xl-5 col-6 d-flex align-items-center justify-content-center">
                  <div>
                    <p class="m-0 title-4">App Bienestar Sherpa</p>
                    <p>App Bienestar Sherpa Como parte de la comunidad de Mimente.com, tendrás acceso a nuestra aplicación de Sherpa Bienestar para acompañarte en tu viaje hacia el bienestar emocional y mental.</p>
                    <p>En el app encontrarás herramientas efectivas para mejorar la calidad de tu sueño, un diario digital para reflexionar sobre tu día, meditaciones guiadas, un check-in de emociones, una representación visual de tu vida emocional en forma de píxeles y mucho más.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="pills-cuidado-moderado" role="tabpanel" aria-labelledby="pills-cuidado-moderado-tab">
              <div class="row">
                <div class="col-xl-5 offset-xl-1 col-6 d-flex align-items-center justify-content-center">
                  <img class="" src="@/assets/landingpage/landing-v4-04.png" alt="">
                </div>
                <div class="col-xl-5 col-6 d-flex align-items-center justify-content-center">
                  <div>
                    <p class="m-0 title-4">Diagnósticos</p>
                    <p>Diagnósticos basados en ciencia con resultados para poder tener una foto de tu empresa por área y que tu personal tenga una foto de su salud mental.</p>
                    <p class="m-0 title-4">Talleres</p>
                    <p>Impartidos por especialistas para mejorar el bienestar emocional, diseñados en base a las necesidades de cada área de tu empresa.</p>
                    <p class="m-0 title-4">Pláticas interactivas</p>
                    <p>Discusiones sobre los temas más relevantes para mejorar el bienestar emocional de todo tu personal y sus familiares.</p>
                    <p class="m-0 title-4">Coaching 360° </p>
                    <p>Incluye sesiones con especialistas en nutrición, sueño y médicos funcionales.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="pills-cuidado-profundo" role="tabpanel" aria-labelledby="pills-cuidado-profundo-tab">
              <div class="row">
                <div class="col-xl-5 offset-xl-1 col-6 d-flex align-items-center justify-content-center">
                  <img class="" src="@/assets/landingpage/landing-v4-03.png" alt="">
                </div>
                <div class="col-xl-5 col-6 d-flex align-items-center justify-content-center">
                  <div>
                    <p class="m-0 title-4">Terapia</p>
                    <p>Dedicada al cuidado profundo de colaboradores en las empresas, promoviendo su bienestar emocional y profesional. Contamos con dos modalidades: Terapia CBT siguiendo el enfoque cognitivo conductual y Terapia Prime, que integra enfoques diversos para una atención aún más completa.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- fin -->

        </div>
      </div>
    </div>
    <!-- end section 4 -->


    <!-- start section 4.5 -->
    <div class="container-fluid d-md-none pb-5" id="section-3">
      <div class="row">
        <div class="col-12 mb-4">
          <div class="card-container-section-4_5">
            <div class="row">
              <div class="col-12">
                <p class="card-title-section-4_5 text-uppercase">cuidado preventivo</p>
              </div>
              <div class="col-12 d-flex align-items-center justify-content-center">
                <img height="250" class="pt-3 pb-3" src="@/assets/landingpage/landing-v4-02.png" alt="">
              </div>
              <div class="col-12 custom-padding-section-4_5">
                <p class="card-p-4_5 m-0">App Bienestar Sherpa</p>
                <p>
                  Como parte de la comunidad de Mimente.com, tendrás acceso a nuestra aplicación de Sherpa Bienestar para acompañarte en tu viaje hacia el bienestar emocional y mental.
                </p>
                <p>En el app encontrarás herramientas efectivas para mejorar la calidad de tu sueño, un diario digital para reflexionar sobre tu día, un check-in de emociones, meditaciones guiadas, una representación visual de tu vida emocional en forma de píxeles y mucho más.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mb-4">
          <div class="card-container-section-4_5">
            <div class="row">
              <div class="col-12">
                <p class="card-title-section-4_5 text-uppercase">cuidado moderado</p>
              </div>
              <div class="col-12 d-flex align-items-center justify-content-center">
                <img class="img-rounded pt-3 pb-3" height="250" src="@/assets/landingpage/landing-v4-04-mobile.png" alt="">
              </div>
              <div class="col-12 custom-padding-section-4_5">
                <p class="card-p-4_5 m-0">Diagnósticos</p>
                <p>Diagnósticos basados en ciencia con resultados para poder tener una foto de tu empresa por area y que tu colaborador tenga una foto de su salud mental.</p>
                <p class="card-p-4_5 m-0">Talleres</p>
                <p>Impartidos por expertos para mejorar el bienestar emocional, diseñados en base a las necesidades de cada area de tu empresa.</p>
                <p class="card-p-4_5 m-0">Pláticas interactivas</p>
                <p>Discusiones sobre los temas mas relevantes para mejorar el bienestar emocional de todos tus colaboradores y sus familias.</p>
                <p class="card-p-4_5 m-0">Coaching 360° </p>
                <p>Incluye sesiones con nutriólogos, especialistas en sueño y médicos funcionales</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mb-4">
          <div class="card-container-section-4_5">
            <div class="row">
              <div class="col-12">
                <p class="card-title-section-4_5 text-uppercase">cuidado profundo</p>
              </div>
              <div class="col-12 d-flex align-items-center justify-content-center">
                <img class="img-rounded pt-3 pb-3" height="250" src="@/assets/landingpage/landing-v4-03-mobile.png" alt="">
              </div>
              <div class="col-12 custom-padding-section-4_5">
                <p class="card-p-4_5 m-0">Terapia</p>
                <p>Dedicada al cuidado profundo de los colaboradores en las empresas, promoviendo su bienestar emocional y profesional. Contamos con dos modalidades: Terapia CBT siguiendo el enfoque cognitivo conductual y Terapia Prime, que integra enfoques diversos para una atención aún más completa.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- end section 4.5 -->

    <!-- start section 5 -->
    <div class="container-fluid d-none d-md-block" id="section-5">
      <div class="">
        <div class="row">
          <div class="col-xl-10 offset-xl-1">
            <div class="blue-background px-2">
              <span class="uppercase badge-title">situación actual</span>
              <p class="title-2">El costo oculto de las empresas</p>
              <div class="row">
                <div class="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1 col-md-12">
                  <div class="row d-flex justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-4">
                      <div class="card-2">
                        <p class="title">México es el 1° lugar en estrés laboral</p>
                        <p class="description">En el mundo, con al menos un 75% de la población económicamente activa padeciendo esta condición.</p>
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-4">
                      <div class="card-2">
                        <p class="title">Ansiedad: 1ra causa de discapacidad laboral</p>
                        <p class="description">En México. El 19.3% de los trabajadores padece de ansiedad severa. <sup>1</sup></p>
                        <span>1 Encuesta Nacional de Bienestar<br>Autorreportado, INEGI</span>
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-4">
                      <div class="card-2">
                        <p class="title">Retorno de $4 USD por cada $1 USD</p>
                        <p class="description">En mejora de la salud y capacidad laboral cuando las organizaciones y gobiernos invierten para ampliar el tratamiento de la depresión y la ansiedad. <sup>2</sup></p>
                        <span>2 Organización Mundial<br>de la Salud (OMS)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 5 -->

    <!-- start section 5.5 -->
    <div class="container-fluid blue-background d-md-none" id="section-5">
      <div class="row">
        <div class="col-12">
          <span class="uppercase badge-title">situación actual</span>
          <p class="title-2">El costo oculto de las empresas</p>
          <!-- inicio -->
          <div class="swiper mySwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="row d-flex align-content-center justify-content-center">
                  <div class="col-10 card-2 slide-min-height">
                    <p class="title">México es el 1° lugar en estrés laboral</p>
                    <p class="description">En el mundo, con al menos un 75% de la población económicamente activa padeciendo esta condición.</p>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="row d-flex align-content-center justify-content-center">
                  <div class="col-10 card-2 me-3 ms-3 slide-min-height">
                    <p class="title">Ansiedad: 1ra causa de discapacidad laboral</p>
                    <p class="description">En México. El 19.3% de los trabajadores padece de ansiedad severa. <sup>1</sup></p>
                    <span>1 Encuesta Nacional de Bienestar<br>Autorreportado, INEGI</span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="row d-flex align-content-center justify-content-center">
                  <div class="col-10 card-2 slide-min-height">
                    <p class="title">Retorno de $4 USD por cada $1 USD</p>
                    <p class="description">En mejora de la salud y capacidad laboral cuando las organizaciones y gobiernos invierten para ampliar el tratamiento de la depresión y la ansiedad. <sup>2</sup></p>
                    <span>2 Organización Mundial<br>de la Salud (OMS)</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <!-- fin -->
        </div>
      </div>
    </div>
    <!-- end section 5.5 -->

    <!-- start section 6 -->
    <div class="container-fluid text-center" id="section-6">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="title-2">Demostración personalizada para tu empresa</p>
            <p class="">Solicita un demo para descubrir cómo podemos apoyar a tu equipo de manera más efectiva.</p>
            <a class="btn mm-btn mm-btn-primary btn-custom-padding uppercase custom-button mt-3" href="#section-9">Solicitar demo</a>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 6 -->

    <!-- start section 7 -->
    <div class="container-fluid d-none d-md-block" id="section-7">
      <div class="container">
        <div class="row">
          <div class="text-center">
            <p class="title">Beneficios y resultados</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row pb-5">
              <div class="col-3 d-flex justify-content-center align-items-center">
                <img class="item-img" src="@/assets/landingpage/landing-v4-08.svg" alt="">
              </div>
              <div class="col-9 justify-content-center align-self-center">
                <p class="title-4">Atención especializada</p>
                <p class="description">MiMente brinda un apoyo integral para tus colaboradores y sus familias en cada etapa de su terapia. De esta manera se generan cambios positivos en todos los ámbitos; tanto personales, familiares y profesionales.</p>
              </div>
            </div>
            <div class="row pb-5">
              <div class="col-3 d-flex justify-content-center align-items-center">
                <img class="item-img" src="@/assets/landingpage/landing-v4-09.svg" alt="">
              </div>
              <div class="col-9 justify-content-center align-self-center">
                <p class="title-4">Hecho a tu medida</p>
                <p class="description">MiMente ofrece un servicio personalizado que se adapta a las necesidades de tu equipo y empresa. Ofrecemos diversas formas de apoyar a tu talento, desde el autocuidado y talleres hasta coaching y terapia</p>
              </div>
            </div>
            <div class="row pb-5">
              <div class="col-3 d-flex justify-content-center align-items-center">
                <img class="item-img" src="@/assets/landingpage/landing-v4-10.png" alt="">
              </div>
              <div class="col-9 justify-content-center align-self-center">
                <p class="title-4">Impulso a la productividad empresarial</p>
                <p class="description">Las empresas que implementan nuestras soluciones observan un aumento en la eficiencia operativa y un entorno laboral más positivo y comprometido, lo que impulsa directamente la productividad general.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 7 -->

    <!-- start section 7 mobile -->
    <div class="container-fluid d-block d-md-none" id="section-7">
      <div class="row">
        <div class="text-center">
          <p class="title">Beneficios y resultados</p>
        </div>
      </div>
      <div class="row justify-content-center align-items-center">
        <div class="col-10">
          <!-- inicio -->
          <div class="swiper mySwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="row section-7-min-height justify-content-center align-items-center">
                  <div class="col-12">
                    <div class="section-7-mobile-img1-bg">&nbsp;</div>
                  </div>
                  <div class="col-12">
                    <div class="section-7-mobile-description">
                      <p class="title-card-section">Atención especializada</p>
                      <p>MiMente brinda un apoyo integral para tus colaboradores y sus familias en cada etapa de su terapia. De esta manera se generan cambios positivos en todos los ámbitos; tanto personales, familiares y profesionales.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="row section-7-min-height justify-content-center align-items-center">
                  <div class="col-12">
                    <div class="section-7-mobile-img2-bg">&nbsp;</div>
                  </div>
                  <div class="col-12">
                    <div class="section-7-mobile-description">
                      <p class="title-card-section">Hecho a tu medida</p>
                      <p>MiMente ofrece un servicio personalizado que se adapta a las necesidades de tu equipo y empresa. Ofrecemos diversas formas de apoyar a tu talento, desde el autocuidado y talleres hasta coaching y terapia.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="row section-7-min-height justify-content-center align-items-center">
                  <div class="col-12">
                    <div class="section-7-mobile-img3-bg">&nbsp;</div>
                  </div>
                  <div class="col-12">
                    <div class="section-7-mobile-description">
                      <p class="title-card-section">Impulso a la productividad empresarial</p>
                      <p>Las empresas que implementan nuestras soluciones observan un aumento en la eficiencia operativa y un entorno laboral más positivo y comprometido, lo que impulsa directamente la productividad general.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <!-- fin -->
        </div>
      </div>
    </div>
    <!-- end section 7 mobile -->

    <div class="container-fluid" id="section-7_5">
      <div class="container">
        <div class="row">

          <div class="col-12 text-center pb-md-4">
            <p class="title">DIFERENCIADORES</p>
          </div>

          <div class="col-sm-12 col-md-12">
            <table class="table-comparative">
              <tr class="no-boder">
                <td style="width: 60%" class="big-title">TECNOLOGÍA</td>
                <td style="width: 20%"><p class="mimente-logo">
                  <img class="mimente" src="@/assets/landingpage/logo_mimente_tabla.svg" alt="">
                </p></td>
                <td style="width: 20%"><p class="others">OTROS</p></td>
              </tr>
              <tr>
                <td>
                  <p class="description">Plataforma digital con tecnología de punta</p>
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
                <td>
                  <img class="uncheck" src="@/assets/landingpage/uncheck.svg" alt="">
                </td>
              </tr>
              <tr>
                <td>
                  <p class="description">Aplicación para uso diario</p>
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
                <td>
                  <img class="uncheck" src="@/assets/landingpage/uncheck.svg" alt="">
                </td>
              </tr>
              <tr>
                <td>
                  <p class="description">Algoritmo para canalizar psicólogos especialistas</p>
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
                <td>
                  <img class="uncheck" src="@/assets/landingpage/uncheck.svg" alt="">
                </td>
              </tr>
              <tr>
                <td>
                  <p class="description">Diagnósticos digitales</p>
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
                <td>
                  <img class="uncheck" src="@/assets/landingpage/uncheck.svg" alt="">
                </td>
              </tr>


              <tr class="no-boder">
                <td class="big-title pt-5">EXPERTOS</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <p class="description">Psicólogos expertos con maestrías y doctorados</p>
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
                <td>
                  <img class="uncheck" src="@/assets/landingpage/uncheck.svg" alt="">
                </td>
              </tr>
              <tr>
                <td>
                  <p class="description">Cursos mensuales</p>
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
              </tr>
              <tr class="no-boder">
                <td>
                  <p class="description">Flexibilidad en la atención</p>
                </td>
                <td>
                  <img class="check" src="@/assets/landingpage/check.svg" alt="">
                </td>
                <td>
                  <img class="uncheck" src="@/assets/landingpage/uncheck.svg" alt="">
                </td>
              </tr>
            </table>
          </div>

        </div>
      </div>
    </div>

    <!-- start section 8 -->
    <div class="container-fluid" id="section-8">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-5">
            <img class="section-7-img" src="@/assets/landingpage/Manos1.png" alt="">
          </div>
          <div class="col-12 col-md-7 text-center">
            <p class="section-8-title">Tu equipo está<br>en las mejores manos</p>
            <p class="section-8-text">Todos nuestros especialistas cuentan con:</p>
            <p class="section-8-list-item">
              MÍNIMO 3 AÑOS DE EXPERIENCIA DANDO TERAPIA
            </p>
            <p class="section-8-list-item">
              ESTUDIOS A NIVEL MAESTRÍA O DOCTORADO
            </p>
            <p class="section-8-list-item">
              PROCESO DE SELECCIÓN, ENTREVISTAS Y ROLE PLAY
            </p>
            <p class="section-8-list-item">
              VALORACIÓN DE SU INTELIGENCIA EMOCIONAL Y MORAL
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 8 -->

    <!-- start section 10 -->
    <div class="container-fluid" id="section-7">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <!-- inicio -->
            <div class="swiper mySwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(t, index) in testimoniales" :key="index">
                  <testimonial :testimonial="t"/>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <!-- fin -->
          </div>
        </div>
      </div>
    </div>
    <!-- end section 10 -->

    <!-- start section 9 -->
    <div class="col-12" id="section-9">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <p class="section-9-title mb-2">Lleva a tu equipo a su mejor nivel</p>
            <p class="talk-with-us mb-5">Platica con nosotros</p>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <div class="form-group has-validation" :class="{'has-error' : name_has_error}">
                  <input type="text" class="form-control" placeholder="* Nombre completo" v-model="comments.name">
                </div>
              </div>
              <!--              <div class="col-12 col-md-6">-->
              <!--                <div class="form-group has-validation">-->
              <!--                  <input type="text" class="form-control" placeholder="Apellido" v-model="comments.last_name">-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="col-12 col-md-6">
                <div class="form-group has-validation" :class="{'has-error' : phone_has_error}">
                  <input type="text" class="form-control" placeholder="* Teléfono" v-model="comments.phone">
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group has-validation" :class="{'has-error' : email_has_error}">
                  <input type="text" class="form-control" placeholder="* Email" v-model="comments.email">
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group has-validation" :class="{'has-error' : business_has_error}">
                  <input type="text" class="form-control" placeholder="* Empresa" v-model="comments.business">
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group has-validation" :class="{'has-error' : persons_total_has_error}">
                  <input type="text" class="form-control" placeholder="Número de colaboradores" v-model="comments.persons_total">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button class="btn mm-btn mm-btn-primary btn-custom-padding uppercase custom-button mt-3" @click="sendComments">Enviar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 9 -->

    <div class="footer-parent p-4">

      <!-- Big logo section -->
      <div class="col-12">
        <section id="big-logo-section">
          <div class="container-xxl g-3">
            <div class="row">
              <div class="col-12 text-center">
                <img src="@/assets/images/landingv2/logo_mimente_tabla.svg" alt="MiMente">
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- Big logo section ends -->

      <main-footer></main-footer>

    </div>

  </div>
</template>

<script>
import {useI18n} from 'vue-i18n'
import {computed, defineAsyncComponent, onMounted, onUnmounted, ref} from 'vue';
import MainFooter from '@/components/FooterV2.vue'
import {useRoute, useRouter} from 'vue-router';
import {useStore} from 'vuex';
import AOS from 'aos';
import 'aos/dist/aos.css';
import psychologistService from '@/services/psychologistService';
import swalUtil from '@/utils/sweetalertUtil'
import Table from "@/components/Jtable/Table";
import Testimonial from '@/components/Testimonial.vue';

export default {
  components: {
    Table,
    MainFooter,
    Testimonial,
    MainHeader: defineAsyncComponent(() => import('@/components/HeaderV2.vue')),
  },
  setup() {
    const {t} = useI18n();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const toggleSections = ref({
      'section_6_more_1': false,
      'section_6_more_2': false,
      'section_6_more_3': false,
      'section_6_more_4': false
    });

    const testimoniales = ref([
      {
        id: 1,
        text: "Como emprendedores, debemos romper el estigma de la terapia; es nuestro aliado más valioso en esta montaña rusa, una herramienta clave para navegar con claridad y resiliencia en el viaje del emprendimiento.",
        author: "Alfonso",
        photo: require("@/assets/landingpage/v4/ALFONSO.png"),
      },
      {
        id: 2,
        text: "La terapia le sirve a todos. En los momentos buenos y en los malos.",
        author: "Beba",
        photo: require("@/assets/landingpage/v4/BEBA 2.png"),
      },
      {
        id: 3,
        text: "Mimente es muy práctico y fácil de usar con una gran variedad de psicólogos para apoyar en cualquier tema",
        author: "Jorge",
        photo: require("@/assets/landingpage/v4/JORGE 3.png"),
      },
      {
        id: 4,
        text: "Mimente es un lugar muy práctico por que todo esta en un mismo lugar.",
        author: "Isabella",
        photo: require("@/assets/landingpage/v4/ISABELLA 4.png"),
      },
      {
        id: 5,
        text: "Una empresa que invierte en la salud mental de su gente no solo humaniza el lugar de trabajo, si no también potencializa su productividad y la innovación.",
        author: "Hector",
        photo: require("@/assets/landingpage/v4/HECTOR 5.png"),
      },
      {
        id: 5,
        text: "Mimente es mi oportunidad de tomar mi consulta psicológica desde mi lugar seguro para poder avanzar en mi proceso de sanación personal.",
        author: "Cinthya",
        photo: require("@/assets/landingpage/v4/CINTHYA 6.png"),
      }
    ]);

    const comments = ref({});
    const name_has_error = ref(false);
    const email_has_error = ref(false);
    const phone_has_error = ref(false);
    const business_has_error = ref(false);
    const comments_has_error = ref(false);
    const videoSound = ref(true);
    const landingWidth = ref(null);
    const pillClicked = ref('pills-cuidado-preventivo')

    const loggedUser = computed(() => store.getters['auth/getLoggedUser'])
    let listener = null;

    const muteVideo = () => {
      setTimeout(() => {
        if (landingWidth.value > 768)
          document.getElementById("my-player").muted = !videoSound.value;
        else
          document.getElementById("my-player-mobile").muted = !videoSound.value;
        videoSound.value = !videoSound.value;
      }, 100)
    }

    const sendComments = async () => {

      name_has_error.value = false
      email_has_error.value = false
      phone_has_error.value = false
      business_has_error.value = false

      if (comments.value?.name !== undefined &&
          comments.value?.phone !== undefined &&
          comments.value?.email !== undefined &&
          comments.value?.business !== undefined
      ) {

        const {data} = await psychologistService.saveClientCommentsV2(comments.value);
        const {result} = data;
        if (!result.error) {

          comments.value = {}

          await swalUtil.fire({
            icon: "success",
            title: 'Información enviada',
            text: 'Gracias por enviarnos tus comentarios. Nos comunicaremos contigo a la brevedad.',
            customClass: 'sherpa-alert',
            backdrop: 'rgba(255,255,255,0.8)',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        } else {
          await swalUtil.fire({
            icon: "success",
            title: 'Tenemos problemas en procesar tu información',
            text: 'Favor de intentar más tarde.',
            customClass: 'sherpa-alert',
            backdrop: 'rgba(255,255,255,0.8)',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }

      } else {

        if (comments.value.name == undefined) {
          name_has_error.value = true
        }

        if (comments.value.phone == undefined) {
          phone_has_error.value = true
        }

        if (comments.value.email == undefined) {
          email_has_error.value = true
        }

        if (comments.value.business == undefined) {
          business_has_error.value = true
        }

      }

    }

    const goToReasons = () => router.push({name: 'reasons-page'})

    const goToLogin = () => {
      const loginModal = new bootstrap.Modal(document.getElementById('loginModal'))
      loginModal.show()
    }

    const openRegisterB2b = () => {
      const b2bRegisterModal = new bootstrap.Modal(document.querySelector('#b2bRegisterModal'))
      b2bRegisterModal.show()
      toggleSidenav()
    }

    const logout = () => {
      store.commit('auth/logout')
      router.push({name: 'login-page'})
    }

    const openCard = ({target}) => {
      toggleSections.value[target.id] = !toggleSections.value[target.id];
    }

    const onClickPill = (id) => {
      pillClicked.value = id
    }

    const isB2CRoute = computed(() => route.name == 'personal-lading-page');

    onMounted(() => {
      AOS.init({
        duration: 2000
      });

      if (route.name == 'landing-page-family') {
        store.commit('auth/setIsFamilyRoute', true);
        // openRegisterB2b();
      } else {
        store.commit('auth/setIsFamilyRoute', false);
      }

      store.commit('setGeneralIsLoading', false);
      landingWidth.value = document.body.offsetWidth;
      listener = window.addEventListener("resize", () => {
        landingWidth.value = document.body.offsetWidth;
      });
      var swiper = new Swiper(".mySwiper", {
        direction: "horizontal",
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 30,
        mousewheel: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    })

    onUnmounted(() => {
      document.querySelector('body').removeAttribute('data-aos-easing')
      window.removeEventListener("resize", listener);
    })

    return {
      router,
      loggedUser,
      toggleSections,
      videoSound,
      comments,
      name_has_error,
      email_has_error,
      comments_has_error,
      landingWidth,
      isB2CRoute,
      pillClicked,
      testimoniales,
      phone_has_error,
      business_has_error,
      t,
      onClickPill,
      goToReasons,
      openCard,
      goToLogin,
      logout,
      openRegisterB2b,
      muteVideo,
      sendComments
    }
  }
}

</script>

<style scoped>

.img-rounded {
  border-radius: 25px;
}

.section-7-min-height {
  min-height: 400px;
}

.section-7-mobile-img1-bg {
  width: 100%;
  height: 200px;
  background-image: url('@/assets/landingpage/landing-v4-08-mobile.png');
  background-size: cover; /* La imagen cubre todo el ancho del div */
  background-position: center; /* Centra la imagen vertical y horizontalmente */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

.section-7-mobile-img2-bg {
  width: 100%;
  height: 200px;
  background-image: url('@/assets/landingpage/landing-v4-09-mobile.png');
  background-size: cover; /* La imagen cubre todo el ancho del div */
  background-position: center; /* Centra la imagen vertical y horizontalmente */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

.section-7-mobile-img3-bg {
  width: 100%;
  height: 200px;
  background-image: url('@/assets/landingpage/landing-v4-10-mobile.png');
  background-size: cover; /* La imagen cubre todo el ancho del div */
  background-position: center; /* Centra la imagen vertical y horizontalmente */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

.section-7-mobile-description {
  background-color: #FAF6EE;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  padding: 10px 15px;
  min-height: 295px;
}

#section-3_5 {
  background: white !important;
  color: #567393 !important;
}

/* start section 4_5 */
.card-container-section-4_5 {
  background-color: #E7EBEF;
  border-radius: 25px;
  /* padding: 15px; */
}

.card-title-section-4_5 {
  background-color: #567393;
  padding: 22px 10px;
  border-radius: 25px;
  text-align: center;
  color: white;
  font-weight: 500;
}

.custom-padding-section-4_5 {
  padding: 1rem 2rem;
}

.card-p-4_5 {
  font-weight: 500;
}

/* end section 4_5 */


/* section7.5 */

#section-7_5 {
  background: white;
  padding: 60px 0;
}

#section-7_5 .title {
  background-color: #E7EBF0;
  color: #293547;
  padding: 12px 55px;
  font-size: 15px;
  font-family: var(--mm-btn-font);
  border-radius: 41px;
  text-transform: uppercase;
  display: inline-block;
  max-width: 700px;
  width: 100%;
}

#section-7_5 .table-comparative p {
  margin: 0;
}

#section-7_5 .table-comparative {
  width: 100%;
}

#section-7_5 .table-comparative .big-title {
  color: #293547;
  font-size: 16px;
  font-weight: 500;
}

#section-7_5 .table-comparative tr.no-boder td {
  border-bottom: 1px solid transparent;
}

#section-7_5 .table-comparative tr td {
  border-bottom: 1px solid #567393;
}

#section-7_5 .table-comparative tr td:nth-child(2), #section-7_5 .table-comparative tr td:nth-child(3) {
  text-align: center;
}

#section-7_5 .table-comparative tr td:nth-child(2) {
  background: #E7EBF0;
}

#section-7_5 .table-comparative .mimente-logo {
  text-align: center;
  background: #567393;
  border-radius: 10px;
  color: white;
  padding: 5px 45px 9px 45px;
  display: inline-block;
  width: 100%;
}

#section-7_5 .table-comparative tr:first-child td:nth-child(2) {
  border-radius: 20px 20px 0px 0px;
}

#section-7_5 .table-comparative tr:last-child td:nth-child(2) {
  border-radius: 0 0 20px 20px;
}

#section-7_5 .table-comparative .others {

}


#section-7_5 .table-comparative .description {
  color: #293547;
  padding: 9px 0;
}

#section-7_5 .table-comparative .check {
  width: 23px;
}

#section-7_5 .table-comparative .mimente {
  width: 95px;
}

#section-7_5 .table-comparative .uncheck {
  width: 14px;
}

/* end section 7.5 */


.custom-button {
  color: white;
  font-size: 16px;
  border-radius: 100px;
  padding: 5px 20px;
  font-family: 'Basier Circle';
  min-width: 165px;
}

.has-validation.has-error input, .has-validation.has-error textarea {
  border: 1.5px solid red !important;
}

.title {
  font-size: 63px;
  font-weight: 500;
  font-family: 'Basier Circle';
  line-height: 1;
}

.title-2 {
  font-size: 42px;
  font-weight: 500;
  font-family: 'Basier Circle';
  line-height: 42px;
  margin: 0;
}

.title-3 {
  font-size: 32px;
  font-weight: 500;
  color: #567393;
  font-family: 'Basier Circle';
  margin-bottom: 30px;
}

.title-4 {
  font-weight: 500;
  font-size: 22px;
  font-family: 'Basier Circle';
  color: #567393 !important;
}

/* section1 */
#section-1 {
  width: 100%;
  height: auto;
  position: relative;
  color: #567393;
  padding: 135px 0px 75px 0px;
}

.section-1-image {
  /*height: 400px;*/
  width: 100%;
  max-width: 610px;
  /*width: auto;*/
  padding: 20px 0;
}

/* end section 1 */
/* start section 2 */

#section-2 {
  color: #567393;
}

.bg-ligth-blue {
  background-color: #E7EBF0;
  padding: 60px 260px;
}

/* end sectin 2 */

/* section 3 start  */
#section-3 {
  color: #36465E;
  background: white;
}

.section-3-grid {
  display: grid;
  border: 1px solid #E7EBF0;
  border-radius: 25px;
  padding: 40px;
}

#section-3 .title-4 {
  color: #36465E;
  font-size: 21px;
  margin-bottom: 0px;
}

.img-container {
  padding-bottom: 40px;
}

.img-container img {
  height: 100px;
  width: auto;
}

#section-3 .description {
  color: #567393;
}

#section-3 .sub-banner {
  margin: 0;
  color: #8095A8;
  font-size: 18px;
}

#section-3 .circles-content {
  padding: 35px 0;
}

#section-3 .circles-content .circle {
  height: 10px;
  width: 10px;
  background: white;
  border: 1px solid #8095A8;
  border-radius: 100px;
}

#section-3 .circles-content .circle.active {
  background: #8095A8;
}


#section-3 .line-border {
  height: 1px;
  background: #8095A8;
  margin-top: -40px;
  margin-left: 17%;
  margin-right: 17%;
}

/* section 3 end */

/* section 4 start */
.mm-btn-tabs.mm-btn-tab {
  background-color: #E7EBF0;
  color: black;
}

.mm-btn-tabs.mm-btn-tab.active {
  background-color: #567393;
  color: white;
}

.btn.mm-btn-tabs {
  padding: 8px 55px;
  font-size: 15px;
  font-family: var(--mm-btn-font);
  border-radius: 41px;
}

/* section 4 end */

/* section 5 start  */

#section-5 {
  background: white;
  padding-bottom: 70px;
  padding-top: 70px;
}

#section-5 .title-2 {
  font-size: 32px;
  font-weight: 500;
  color: white;
  font-family: 'Basier Circle';
  margin: 0;
  padding: 70px 0 60px 0;
}

.blue-background {
  background-color: #293547 !important;
  border-radius: 30px;
  position: relative;
  padding: 0 0 60px 0px;
  text-align: center;
  color: white;
}

.badge-title {
  position: absolute;
  top: 0;
  left: 50%;
  background-color: #E7EBF0;
  color: #293547;
  transform: translate(-50%, -50%);
  padding: 8px 55px;
  font-size: 15px;
  font-family: var(--mm-btn-font);
  border-radius: 41px;
  text-transform: uppercase;
  min-width: 280px;

}

.card-2 {
  background-color: #FFFFFF;
  border-radius: 25px;
  color: #567393;
  padding: 0;
  min-height: 370px;
}

.card-2 .title {
  background: #E7EBF0;
  font-size: 18px;
  color: #567393;
  padding: 30px 25px;
  border-radius: 25px;
  font-weight: 500;
  margin: 0;
}

.card-2 .description {
  margin: 0;
  font-size: 16px;
  padding: 35px 33px 11px 33px;
  min-height: 205px;
}

.card-2 span {
  margin: 0;
  font-size: 14px;
  padding: 10px 10px 22px 10px;
  /* padding-bottom: 35px; */
  color: #a5a5a5;
  font-family: 'GT America Mono';
  text-align: center;
  line-height: 16px;
  display: inline-block;
}

/* section 5 end */

/* section 6 start */
#section-6 {
  background-color: #E7EBF0;
  padding: 40px 0;
  color: #567393;
}

.item-img {
  height: auto;
  width: 200px;
}

#section-6 .title-2 {
  font-size: 32px;
  font-weight: 500;
  color: #567393;
  font-family: 'Basier Circle';
  margin: 0;
  padding: 0;
}

/* section 6 end */

/* section 7 start */

#section-7 {
  color: #567394;
  font-family: 'Basier Circle';
  padding: 40px 0;
}

.section-8-list-item {
  border-radius: 100px;
  padding: 15px 30px;
  font-size: 15px;
  font-family: var(--mm-font-gt-america-mono);
  background: white;
  color: #8095A8;
  display: inline-block;
  min-width: 520px;
}

.section-7-img {
  width: 100%;
}

#section-7 .title {
  font-size: 32px;
  font-weight: 500;
  color: #567393;
  font-family: 'Basier Circle';
  margin: 0;
  padding: 0;
  margin-bottom: 35px;
}

#section-7 .title-4 {
  color: #36465E;
  font-size: 21px;
  margin-bottom: 0px;
}

#section-7 .description {
  color: #36465E;
  margin: 0;
}

/* section 7 end */


/* section 8 start */
#section-8 {
  color: #567394;
  font-family: 'Basier Circle';
  padding: 40px 0;
  background: #E7EBF0;
}

.section-8-title {
  font-size: 32px;
  font-weight: 500;
  color: #567393;
  font-family: 'Basier Circle';
  margin: 0;
  padding: 0;
  margin-bottom: 20px;
  line-height: 35px;
}

.section-8-text {
  color: #8095A8;
  font-size: 18px;
}

/* section 8 end */


/* section 9 start */
#section-9 {
  background-color: #FFE8AE;
  color: #567394;
  font-family: 'Basier Circle';
  padding: 50px;
}


.section-9-title {
  font-size: 32px;
  font-weight: 500;
  color: #567393;
  font-family: 'Basier Circle';
  margin: 0;
  padding: 0;
  margin-bottom: 20px;
  line-height: 35px;
}

.talk-with-us {
  color: #8095A8;
  font-size: 18px;
}

#section-9 input, textarea {
  font-size: 16px;
  border-radius: 20px;
  padding: 20px 12px;
  color: #567394;
  border: 0;
}


.section-9-text {
  font-size: 21px;
}

#section-9-send-button {
  background-color: #567393;
  color: #FFE8AE;
  border-radius: 10px;
  border-color: #567393;
  font-size: 20px;
}

/* section 9 end */

/* section 10 start */

/* section 10 end */

/* Big logo section -----*/
#big-logo-section {
  width: 100%;
  height: auto;
  padding: 50px 0;
}

#big-logo-section img {
  width: 180px;
}

#section-3 .tab-pane img {
  max-height: 400px;
}

p {
  font-size: 18px;
}

.footer-parent {
  background: #36465E;
}

@media (min-width: 0px) and (max-width: 767px) {

  #section-7 {
    background-color: white;
  }

  .section-8-list-item[data-v-4d7d9371] {
    border-radius: 100px;
    padding: 8px 8px;
    font-size: 15px;
    min-width: 100%;
  }

  .badge-title {
    padding: 8px 33px;
  }

  #section-6 .title-2 {
    font-size: 25px;
    padding-bottom: 25px;
  }

  .section-8-title {
    margin-top: 25px;
    font-size: 25px;
  }

  .section-8-text {
    font-size: 18px;
    margin-bottom: 25px;
  }

  #section-7_5 .table-comparative {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 10px !important;
    display: block;
    font-size: 11px;
  }

  .title-3 {
    font-size: 25px;
  }

  .slide-min-height {
    min-height: 350px !important;
  }

  .card-2 .description {
    min-height: 130px;
  }

  .blue-background {
    border-radius: 0px;
  }

  .bg-ligth-blue {
    line-height: 1;
    padding: 20px;
  }

  .section-1-title {
    font-size: 26px;
    line-height: 30px;
    font-weight: 500;
  }

  #section-1 {
    padding-top: 60px;
    padding-right: var(--bs-gutter-x, 0.75rem);
    padding-left: var(--bs-gutter-x, 0.75rem);
  }

  .section-1-image {
    height: 350px;
  }

  #section-1 .container {
    padding: 0;
  }

  .bg-ligth-blue {
    padding: 40px;
  }

  .title-2 {
    font-size: 25px;
    line-height: 25px;
  }

  .section-3-grid {
    grid-template-columns: 110px 1fr;
    gap: 25px;
  }

  /* section 9 start */
  .section-9-text {
    font-size: 20px;
  }

  #section-9 input, textarea {
    font-size: 16px;
    padding: 10px;
  }

  #section-9-send-button {
    font-size: 16px;
  }

  #section-9 {
    /*margin-top: 50px;*/
    /*margin-bottom: 40px;*/
    padding: 40px 10px;
  }

  /* section 9 end */
  #big-logo-section {
    padding: 30px 0 45px 0;
  }

  #big-logo-section img {
    width: 170px;
  }

  .section-3-grid {
    padding: 10px;
  }

  .contact-button-banner {
    background: #E7EBF1 !important;
    color: #567393 !important;
  }

  .badge-title {
    font-size: 18px;
  }

  #section-5 .title-2 {
    font-size: 25px;
    padding: 0px 0 50px 0;
  }

  .card-2 .title {
    font-size: 24px;
    line-height: 30px;
    padding: 25px 35px;
  }

  .title-card-section {
    font-size: 21px;
    color: black;
    padding-top: 10px;
  }

  #section-7_5 .title {
    font-size: 18px;
  }

  #section-7_5 .table-comparative .mimente-logo, #section-7_5 .table-comparative .others {
    padding: 5px 18px 9px 18px;
  }

  #section-7_5 .table-comparative .mimente {
    width: 65px;
  }

  #section-7_5 .table-comparative .others {
    font-size: 15px;
  }

}

/* @media (min-width: 577px) and (max-width: 767px) {

  .section-1-title {
    font-size: 25px;
    font-weight: 500;
  }

  .bg-ligth-blue {
    line-height: 1;
    padding: 20px;
  }

  .title-2 {
    font-size: 25px;
  }

  .section-3-grid {
    grid-template-columns: 110px 1fr;
    gap: 5px;
  }
} */

@media (min-width: 768px) and (max-width: 991px) {
  .section-1-title {
    font-weight: 500;
    font-size: 42px;
  }

  /* section 9 start */
}

@media (min-width: 992px) and (max-width: 1199px) {
  .section-1-title {
    font-weight: 500;
    font-size: 45px;
  }

  /* section 9 start */

}

@media (min-width: 1200px) and (max-width: 1679px) {

  .section-1-title {
    font-weight: 500;
    font-size: 50px;
  }

  /* section 9 start */
}

@media (min-width: 1900px) {

  p {
    font-size: 21px;
  }

  #section-3 .title-4 {
    font-size: 31px;
  }

  #section-3 .sub-banner {
    font-size: 21px;
  }

  .btn.mm-btn-tabs {
    font-size: 18px;
  }

  #section-3 .tab-pane img {
    max-height: 510px;
  }

  .badge-title {
    font-size: 18px;
  }

  .card-2 .title {
    font-size: 22px;
  }

  .card-2 .description {
    font-size: 19px;
  }

  .card-2 span {
    font-size: 15px;
    line-height: 16px;
  }

  .custom-button {
    font-size: 18px;
  }

  #section-7 .title-4 {
    font-size: 23px;
  }

  .item-img {
    width: 230px;
  }

  #section-7_5 .title {
    font-size: 18px;
  }

  #section-7_5 .table-comparative .big-title {
    font-size: 20px;
  }

  .section-8-text {
    font-size: 21px;
  }

  .section-8-list-item {
    font-size: 18px;
    min-width: 570px;
  }

  .talk-with-us {
    font-size: 20px;
  }

}


/*!*Large*!*/
/*@media (min-width: 992px) and (max-width: 1199px)*/
/*  !*Medium*!*/
/*  @media (min-width: 768px) and (max-width: 991px)*/
/*    !*Small*!*/
/*    @media (min-width: 576px) and (max-width: 767px)*/
/*      !*Extra small*!*/
/*      @media (min-width: 0px) and (max-width: 575px)*/


</style>
